import { FactorIdEnum } from 'outshared-lib';

// 'SVJR' and 'BMTR' are used for differtent information tooltips
export const INFORMATION_TOOLTIP_IDS = [
    FactorIdEnum.Content, // INHD - Inhoud
    FactorIdEnum.HomeType, // TWHS - Type woonhuis
    FactorIdEnum.UserSurface, // 'GOPP' - Gebruiksoppervlakte
    FactorIdEnum.BuildYear, // 'BWJR' - Bouwjaar
];
